import { types, onSnapshot, onPatch, setLivelynessChecking, clone } from "mobx-state-tree";

import { ValidationStore } from "./models/Validation";
import { SurveyStore } from "./models/Survey";
import * as Alert from "./models/Alert";
import { QuestionStore } from "./models/Question";
import { AnswerStore } from "./models/Answer";
import { RespondentStore } from "./models/Respondent";
import { GroupStore } from "./models/Group";
import { UserStore } from "./models/User";
import { LocaleStore } from "./models/Locale";
import ConfigStore from "./models/Config";
import { Router } from "./models/Router";

const store = types
  .model("store", {
    $locale: types.optional(LocaleStore, {}),
    $router: types.optional(Router, {}),
    $loading: types.optional(types.boolean, true),
    $alert: types.optional(Alert.store, {}),
    $user: types.optional(UserStore, {}),
    $group: types.optional(GroupStore, {}),
    $validation: types.optional(ValidationStore, {}),
    $survey: types.optional(SurveyStore, {}),
    $question: types.optional(QuestionStore, {}),
    $answer: types.optional(AnswerStore, {}),
    $respondent: types.optional(RespondentStore, {}),
    $config: types.optional(ConfigStore, {})
  })
  .actions(self => ({
    change(property, value) {
      self[property] = value;
    }
  }))
  .create();

onPatch(store, async patch => {
  const { $router, $user, $group, $locale, $respondent } = store;

  //init loading data
  if (patch.path === "/$user/status" && patch.value === "done") {
    $respondent.change("list", {});
    $group.change("list", {});
    $group.detach($group.selected);
    $locale.load();

    // //anoymous
    if ($user.sessionUser.isAnonymous) {
      console.log("anonymous");
      $group.load($router.getURLParameterByName("group"));
    }

    //verified mentor
    if ($user.sessionUser.isVerifiedMentor && !$user.sessionUser.isVerifiedCreator) {
      console.log("verified mentor");
      if ($router.getURLParameterByName("group")) {
        $group.load($router.getURLParameterByName("group"));
      } else {
        $user.sessionUser.groups &&
          $user.sessionUser.groups.forEach(group => {
            $group.load(group);
            $user.loadMeta({ groupKey: group });
          });
      }
    }

    //creator
    if ($user.sessionUser.isVerifiedCreator) {
      await $group.load($router.getURLParameterByName("group"));
    }

    routes(store);
  }

  if (patch.path === "/$router/pathname") {
    routes(store);
  }
});

const routes = async store => {
  const { $survey, $router, $user, $group, $config, $question, $respondent, $alert } = store;

  console.log(">>>>>>>>>>>>>>>>>>>>>ROUTES!!");

  if ($router.page === "") {
    $router.push("/start");
  }

  if ($router.page === "start") {
    if ($user.sessionUser.isVerifiedMentor || $user.sessionUser.isCreator) {
      $router.push("/survey");
    } else if ($user.sessionUser.isVerifiedAuth) {
      $router.push($config.homeSurvey);
    } else {
      $survey.load();
    }

    if ($user.sessionUser.isAnonymous) {
      $user.signOut();
    }
  }

  if ($router.page === "survey") {
    if (!$router.mode) {
      if (!($user.sessionUser.isVerifiedMentor || $user.sessionUser.isCreator)) {
        $router.push("/start");
      }

      if (
        $config.id === "barometer-disco" &&
        $user.sessionUser.isVerifiedMentor &&
        !$user.sessionUser.isVerifiedCreator
      ) {
        $router.push("/survey/share/oHHAvZZm88LO6QqCeNzd");
        return;
      }

      if ($survey.selected) $survey.detach($survey.selected);
      await $survey.load();
    } else {
      if ($router.mode === "view") {
        if ($user.sessionUser.isCreator) {
          $router.push("/survey");
        }

        if (
          !$user.sessionUser.emailVerified &&
          !$user.sessionUser.isCreator &&
          !$user.sessionUser.isAnonymous
        ) {
          $router.push("/start");
        }
      }

      if ($router.mode === "edit") {
        if (!($user.sessionUser.isVerifiedMentor || $user.sessionUser.isCreator)) {
          $router.push("/start");
        }
      }

      if ($router.mode === "share" || $router.mode === "settings") {
        $survey.selected &&
          $group.selected &&
          $survey.selected.generateShareUrl($group.selected._key);
      }

      if ($router.mode === "new") {
        $survey.setSelected("new");
      }

      const snapshot = await $survey.load($router.id);
      if (snapshot && snapshot.exists) {
        $question.loadForSurvey($router.id);
        if ($router.mode === "results") {
          let groupKeys = $group.activeGroupKeys;

          if ($group.selected) {
            await $respondent.load(
              snapshot.id,
              $group.selected._key,
              !$user.sessionUser.isVerifiedMentor && $user.sessionUser.uid
            );
          } else if (groupKeys.length) {
            $respondent.load(snapshot.id, groupKeys);
          } else {
            await $respondent.load(
              snapshot.id,
              false,
              !$user.sessionUser.isVerifiedMentor && $user.sessionUser.uid
            );
          }
        }
      } else {
        $router.push("/survey");
      }
    }
  }

  if ($router.page === "user") {
    if ($user.sessionUser.isVerifiedCreator) {
      if ($router.id) $user.loadUser($router.id);
      else $user.loadMeta();
    } else {
      $user.change("selected", clone($user.sessionUser));
    }
  } else {
    if ($user.unsubscribe) $user.unsubscribe();
  }

  if ($router.page === "group") {
    if (!$router.mode) {
      $group.detach($group.selected);
    }

    if ($router.mode === "new") {
      $group.setSelected({
        _key: "new",
        name: "",
        createdOn: new Date(),
        createdBy: ""
      });
    }

    if ($user.sessionUser.isVerifiedMentor || $user.sessionUser.isCreator) {
      if ($router.id) {
        $group.load($router.id);
      } else !$group.unsubscribe && $group.load();
    }
  }

  store.change("$loading", false);
};

setLivelynessChecking("error");

onSnapshot(store, snapshot => {
  console.log(">>>>> snapshot", snapshot);
  // const { $survey, $router, $user, $group, $config, $locale } = store;

  // if ($router.page === "" || $router.page === "start") {
  //   if ($user.sessionUser.isVerifiedAuth) {
  //     $router.push("/survey");
  //   }
  // }

  // if ($router.page === "survey") {
  //   if (!$router.mode) $survey.detach($survey.selected);

  //   if ($user.sessionUser.isVerifiedMentor) {
  //     if ($router.mode === "view") $router.push("/survey");

  //     if ($router.mode && !$survey.selected && $survey.status === "done") {
  //       $router.key
  //         ? $survey.list.has($router.key)
  //           ? $survey.setSelected($router.key)
  //           : $router.push("/survey")
  //         : $survey.setSelected("new");

  //       if (
  //         $survey.selected.languages &&
  //         !$survey.selected.languages
  //           .split(",")
  //           .find(language => language === $locale.activeLocale)
  //       ) {
  //         $locale.change(
  //           "activeLocale",
  //           $survey.selected.languages.split(",")[0]
  //         );
  //       }
  //     }
  //   }

  //   if (
  //     $user.sessionUser.isVerifiedAuth &&
  //     !$user.sessionUser.isVerifiedMentor
  //   ) {
  //   }
  // }

  // if ($user.status === "done") {
  //   if ($user.sessionUser.isVerifiedMentor) {
  //     if ($router.page === "" || $router.page === "start") {
  //       $router.push("/survey");
  //     }
  //     if ($router.page === "user") {
  //       $router.mode === "signin" && $router.push("/survey");
  //       if ($router.mode && !$user.selected) {
  //         $user.change(
  //           "selected",
  //           $router.key
  //             ? $user.list.has($router.key)
  //               ? clone($user.list.get($router.key))
  //               : $router.push("/user")
  //             : { _key: "new", name: "", createdBy: $user.sessionUser.uid }
  //         );
  //       }
  //     }
  //     if ($router.page === "survey") {
  //       if ($router.mode === "view") $router.push("/survey");
  //       if (!$router.mode) $survey.detach($survey.selected);

  //       if ($router.mode && !$survey.selected && $survey.status === "done") {
  //         $router.key
  //           ? $survey.list.has($router.key)
  //             ? $survey.setSelected($router.key)
  //             : $router.push("/survey")
  //           : $survey.setSelected("new");

  //         if (
  //           $survey.selected.languages &&
  //           !$survey.selected.languages
  //             .split(",")
  //             .find(language => language === $locale.activeLocale)
  //         ) {
  //           $locale.change(
  //             "activeLocale",
  //             $survey.selected.languages.split(",")[0]
  //           );
  //         }

  //         // selectedSurvey.interval_period !== "none" &&
  //         //   $survey.setActiveIntervalPeriod();
  //       }
  //     }
  //     if ($router.page !== "survey") {
  //       $survey.detach($survey.selected);
  //     }

  //     if ($router.page === "group") {
  //       if (!$router.mode) $group.detach($group.selected);
  //       if ($router.mode && !$group.selected && $group.status === "done") {
  //         const selectedGroup = $router.key
  //           ? $group.list.has($router.key)
  //             ? clone($group.list.get($router.key))
  //             : $router.push("/group")
  //           : Group.create({
  //               _key: "new",
  //               name: "",
  //               createdOn: new Date(),
  //               createdBy: $user.sessionUser.uid
  //             });
  //         $group.setSelected(selectedGroup);
  //       }
  //     }
  //   }

  //   if (
  //     ($user.sessionUser.isAnonymous === null ||
  //       $user.sessionUser.isAnonymous ||
  //       !$user.sessionUser.uid ||
  //       $user.sessionUser.isAuth) &&
  //     (!$user.sessionUser.isVerifiedMentor || !$user.sessionUser.emailVerified)
  //   ) {
  //     console.log("-------->", $survey.selected);
  //     if ($router.page === "") {
  //       $router.push($config.home);
  //     } else if (
  //       !($router.page === "start") &&
  //       !($router.page === "survey" && $router.mode === "view") &&
  //       !(
  //         $router.page === "survey" &&
  //         $router.mode === "results" &&
  //         $user.sessionUser.isAnonymous !== null
  //       ) &&
  //       !($router.page === "user" && $router.mode === "register") &&
  //       !($router.page === "user" && $router.mode === "signin")
  //     ) {
  //       $router.push("/start");
  //     }
  //     if ($router.page === "start" && $survey.selected) {
  //       $router.push("/survey/" + $survey.selected._key);
  //     }
  //     if ($router.page === "survey") {
  //       if (
  //         ($router.mode === "view" || $router.mode === "results") &&
  //         !$survey.selected &&
  //         $router.key &&
  //         $survey.status === "done"
  //       ) {
  //         $survey.setSelected($router.key);
  //       }
  //     }
  //     if ($router.getURLParameterByName("group")) {
  //       const groupKey = $router.getURLParameterByName("group");
  //       localStorage.setItem("barometer-group", groupKey);
  //       if (
  //         !$group.selected &&
  //         $group.status === "done" &&
  //         $group.list.has(groupKey)
  //       ) {
  //         $user.sessionUser.addGroup(groupKey);
  //         $group.change(
  //           "selected",
  //           clone($group.list.get(groupKey) || { _key: groupKey })
  //         );
  //       }
  //     }
  //   }
  // }
});

if (process.env.NODE_ENV === "development") {
  window.store = store;
}

export default store;
